//


import {Filtro} from "../../../models/filtro/filtro";
import {CartaCorrecao} from "../../../models/movimentacao/carta_correcao";
import {DFeSCH} from "../../../search/DFeSCH";
import {pegaDados, processar} from "../../../services/GenericAPI";
import {EventBus} from "../../../helpers/event-bus";

const url = '/carta_correcao';
const state = {
  all: [],
  carta_correcao: new CartaCorrecao(),
  filtro: new Filtro()
};
const getters = {
  pegaFiltro: (state) => {
    return state.filtro
  },
  pegaCartaCorrecao: (state) => {
    return state.carta_correcao
  },
  listaChaveAcesso: (state) => {
    return state.all
  }
};


const actions = {
  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', CartaCorrecaoSCH(perPage))
  },
  setCartaCorrecao({commit}, carta) {
    commit('SET_CARTA_CORRECAO', carta)
  },
  async setAllChaveAcesso({ commit },{onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/get', state.filtro)).data;

      commit('SET_CHAVE_ACESSO', list);
      onSucesso()
    } catch (error) {
      console.log(error);
      onErro()
    }
  },
  async processarCartaCorrecao ({ commit }, { acao, onSucesso,onErro }) {
    try {
      let res = await processar(url, state.carta_correcao, acao);
      this.dispatch('geral/setMsgSuccess', res.data.message);
      onSucesso()
    } catch (error) {
      console.log(error);
      onErro();
      this.dispatch('geral/setObjMsgError', error.response.data)

    }
  },
};
const mutations = {
  SET_CHAVE_ACESSO (state, all) {
    state.all = all
  },

  SET_CARTA_CORRECAO (state, carta_correcao) {
    state.carta_correcao = carta_correcao
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
